import { db, FieldValue } from '@/firebaseConfig'

export default {
  state: {
    allProducts: [],
    currentProducts: [],
    itemsPerPage: 24,
    productsCounter: null,
    lastProduct: null,
    favoriteProductsIds: [],
    favoriteProducts: [],
    contactedProductsIds: [],
    messages: []
  },

  mutations: {
    addProductToAllProducts(state, { product, isNewProduct }) {
      if (isNewProduct) {
        state.allProducts.unshift(product)
      } else {
        state.allProducts.push(product)
      }
    },
    updateProductFromAllProducts(state, product) {
      const productIndex = state.allProducts.findIndex(
        item => item.id === product.id
      )
      if (productIndex || productIndex === 0) {
        state.allProducts.splice(productIndex, 1, product)
      }
    },
    deleteProductFromAllProducts(state, product) {
      const productIndex = state.allProducts.findIndex(
        item => item.id === product.id
      )
      state.allProducts.splice(productIndex, 1)
    },
    setProductsCounter(state, total) {
      state.productsCounter = total
    },
    setCurrentProducts(state, products) {
      state.currentProducts = products
    },
    addProductToCurrentProducts(state, { product, isNewProduct }) {
      if (isNewProduct) {
        state.currentProducts.unshift(product)
      } else {
        state.currentProducts.push(product)
      }
    },
    updateProductFromCurrentProducts(state, product) {
      const productIndex = state.currentProducts.findIndex(
        item => item.id === product.id
      )
      if (productIndex || productIndex === 0) {
        state.currentProducts.splice(productIndex, 1, product)
      }
    },
    deleteProductFromCurrentProducts(state, product) {
      const productIndex = state.currentProducts.findIndex(
        item => item.id === product.id
      )
      if (productIndex || productIndex === 0) {
        state.currentProducts.splice(productIndex, 1)
      }
    },
    setLastProduct(state, product) {
      state.lastProduct = product
    }, /* here */
    setFavoriteProductsIds(state, payload) {
      state.favoriteProductsIds = payload
    },
    setFavoriteProducts(state, payload) {
      state.favoriteProducts = payload
    },
    addToFavorites(state, productId) {
      state.favoriteProductsIds.push(productId)
    },
    removeFromFavorites(state, productId) {
      const index = state.favoriteProductsIds.indexOf(productId)
      state.favoriteProductsIds.splice(index, 1)
    },
    addToFavoriteProducts(state, favorite) {
      state.favoriteProducts.push(favorite)
    },
    removeFromFavoriteProducts(state, id) {
      const index = state.favoriteProducts.findIndex(favorite => favorite.id === id)
      state.favoriteProducts.splice(index, 1)
    },
    setContactedProductsIds(state, payload) {
      state.contactedProductsIds = payload
    },
    addToContactedIds(state, productId) {
      state.contactedProductsIds.push(productId)
    }
  },

  actions: {
    async getFirstProducts({ commit }) {
      const products = await db.collectionGroup('products').orderBy('created_at_mills', 'desc').limit(24).get()
      commit('setLastProduct', products.docs[products.docs.length - 1])

      products.forEach(prod => {
        commit('addProductToAllProducts', { product: prod.data(), isNewProduct: false })
        commit('addProductToCurrentProducts', { product: prod.data(), isNewProduct: false })
      })
    },
    async getNextProducts({ commit, getters }) {
      const lastProduct = getters.lastProduct
      commit('setCurrentProducts', [])

      const products = await db.collectionGroup('products').orderBy('created_at_mills', 'desc').startAfter(lastProduct).limit(24).get()

      commit('setLastProduct', products.docs[products.docs.length - 1])

      products.forEach(prod => {
        commit('addProductToAllProducts', { product: prod.data(), isNewProduct: false })
        commit('addProductToCurrentProducts', { product: prod.data(), isNewProduct: false })
      })
    },
    getCurrentStoreProducts({ commit, getters }, pageNumber) {
      const allProducts = getters.allProducts
      const lastElement = pageNumber * getters.itemsPerPage
      const firstElement = lastElement - getters.itemsPerPage
      commit('setCurrentProducts', allProducts.slice(firstElement, lastElement))
    },
    getProductsCounter({ commit }) {
      db.collectionGroup('products').where('size', '>', 0).get()
        .then(async(snap) => {
          let total = 0
          await snap.forEach(doc => {
            total += doc.data().size
          })
          commit('setProductsCounter', total)
        })
    },
    async getFavoriteProductsIds({ commit, getters, dispatch }) {
      const user = getters.user
      let favoriteProductsIds = null
      try {
        switch (user.type) {
          case 'customer':
            favoriteProductsIds = await db.doc(`/customers/${user.id}/customerData/favoriteProductsIds`).get()
            break
          case 'independent':
            favoriteProductsIds = await db.doc(`/independents/${user.id}/supplierData/favoriteProductsIds`).get()
            break
          case 'business':
            favoriteProductsIds = await db.doc(`/businesses/${user.id}/supplierData/favoriteProductsIds`).get()
            break
          default:
            break
        }
        commit('setFavoriteProductsIds', favoriteProductsIds.data().ids)
        dispatch('getFavoriteProducts')
      } catch (err) {
        commit('setError', err)
      }
    },

    async addToFavorites({ commit, getters }, product) {
      const user = getters.user
      let favoritesRef = null
      try {
        switch (user.type) {
          case 'customer':
            favoritesRef = db.doc(`/customers/${user.id}/customerData/favoriteProductsIds`)
            break
          case 'independent':
            favoritesRef = db.doc(`/independents/${user.id}/supplierData/favoriteProductsIds`)
            break
          case 'business':
            favoritesRef = db.doc(`/businesses/${user.id}/supplierData/favoriteProductsIds`)
            break
          default:
            break
        }
        /** Atomically add one element to the 'ids' array field */
        await favoritesRef.update({ ids: FieldValue.arrayUnion(product.id) })
        commit('addToFavorites', product.id)
        commit('addToFavoriteProducts', product)
      } catch (err) {
        commit('setError', err)
      }
    },

    removeFromFavorites_store({ commit }, productId) {
      commit('removeFromFavorites', productId)
      commit('removeFromFavoriteProducts', productId)
    },

    addBackToFavorites({ commit }, product) {
      commit('addToFavorites', product.id)
      commit('addToFavoriteProducts', product)
    },

    async removeFromFavorites({ commit, getters }, productId) {
      const user = getters.user
      let favoritesRef = null
      try {
        switch (user.type) {
          case 'customer':
            favoritesRef = db.doc(`/customers/${user.id}/customerData/favoriteProductsIds`)
            break
          case 'independent':
            favoritesRef = db.doc(`/independents/${user.id}/supplierData/favoriteProductsIds`)
            break
          case 'business':
            favoritesRef = db.doc(`/businesses/${user.id}/supplierData/favoriteProductsIds`)
            break
          default:
            break
        }
        /** Atomically remove one element from the 'ids' array field */
        await favoritesRef.update({ ids: FieldValue.arrayRemove(productId) })
      } catch (err) {
        commit('setError', err)
      }
    },
    getFavoriteProducts({ commit, getters }) {
      const favoriteProductsIds = getters.favoriteProductsIds
      const allProducts = getters.allProducts
      favoriteProductsIds.forEach(async id => {
        // check if it exists in local state
        const prod = allProducts.find(prod => prod.id === id)

        // !!!!! fix this
        if (!prod) {
          commit('addToFavoriteProducts', prod)
        } else {
          // fetch it from firebase
          try {
            const snap = await db.collectionGroup('products').where('id', '==', id).get()
            snap.forEach(doc => {
              commit('addToFavoriteProducts', doc.data())
            })
          } catch (err) {
            commit('setError', err)
          }
        }
      })
    }
  },

  getters: {
    itemsPerPage(state) {
      return state.itemsPerPage
    },
    allProducts(state) {
      return state.allProducts
    },
    productById: state => id => {
      return state.allProducts.find(product => product.id === id)
    },
    currentProducts(state) {
      return state.currentProducts
    },
    productsCounter(state) {
      return state.productsCounter
    },
    lastProduct(state) {
      return state.lastProduct
    },
    favoriteProductsIds(state) {
      return state.favoriteProductsIds
    },
    favoriteProducts(state) {
      return state.favoriteProducts
    },
    contactedProductsIds(state) {
      return state.contactedProductsIds
    }
  }
}
